

import { IBotStatus } from '../interfaces/IBotStatus';
import { Environment } from './Environment';
import DateTimeService from './DateTimeService';
import { Helper } from '../Helper';

export default class BotService {

  public static getBotInstallationStatus = (environment: "Development" | "Test" | "Production", tenant: string) => {
    const api = `${Environment.getEnvironmentForBotApi(environment)}/${tenant}/installation/status`;
    return new Promise<IBotStatus>((resolve: (status: any) => void, reject: (error: any) => void): void => {
      if (environment && tenant) {
        const oldBotInstallationStatus = localStorage.getItem("IA_isOldPlingInstalled");
        if (oldBotInstallationStatus && new DateTimeService().getDatePlusOneHour(new Date(JSON.parse(oldBotInstallationStatus).date)) > new Date()) {
          console.log("Using cached newBotInstallationStatus");
          resolve(JSON.parse(oldBotInstallationStatus).value);
        } else {
          console.log("Fetching newBotInstallationStatus from server");
          fetch(api, {
            credentials: "same-origin",
            headers: { 'Content-Type': 'application/json' }
          }).then((response) => {
            if (!response.ok) {
              reject(response);
              return;
            }
            return response.json().then((jsonResponse) => {
              Helper.setLocalStorage("IA_isOldPlingInstalled", JSON.stringify({
                date: new Date(),
                value: jsonResponse
              }));
              resolve(jsonResponse);
            });
          })
            .catch(error => {
              console.log(error);
              reject(null);
            });
        }
      } else {
        reject(null);
      }
    });
  }

  public static getNewBotInstallationStatus = (environment: "Development" | "Test" | "Production", tenant: string) => {
    const api = `${Environment.getEnvironmentForNewBotApi(environment)}/${tenant}/installation/status`;
    return new Promise<IBotStatus>((resolve: (status: any) => void, reject: (error: any) => void): void => {
      if (environment && tenant) {
        const newBotInstallationStatus = localStorage.getItem("IA_isNewPlingInstalled");
        if (newBotInstallationStatus && new DateTimeService().getDatePlusOneHour(new Date(JSON.parse(newBotInstallationStatus).date)) > new Date()) {
          console.log("Using cached newBotInstallationStatus");
          resolve(JSON.parse(newBotInstallationStatus).value);
        } else {
          console.log("Fetching newBotInstallationStatus from server");
          fetch(api, {
            credentials: "same-origin",
            headers: { 'Content-Type': 'application/json' }
          }).then((response) => {
            if (!response.ok) {
              reject(response);
              return;
            }
            return response.json().then((jsonResponse) => {
              Helper.setLocalStorage("IA_isNewPlingInstalled", JSON.stringify({
                date: new Date(),
                value: jsonResponse
              }));
              resolve(jsonResponse);
            });
          })
            .catch(error => {
              console.log(error);
              reject(null);
            });
        }
      } else {
        reject(null);
      }
    });
  }

}